import {Navigate, Route, Routes, Outlet} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import { Contactenos } from './components/Contactenos'
import { Reclamaciones } from './components/Reclamaciones'
import ContactenosPage from './components/Contactenos/ContactenosPage'
import ReclamacionesPage from './components/Reclamaciones/ReclamacionesPage'

const AdministracionPage = () => {
  const intl = useIntl()

  const widgetsBreadCrumbs: Array<PageLink> = [
    {
      title: 'Administración',
      path: '/menu/administracion/contactenos',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='contactenos'
          element={
            <>
              <PageTitle breadcrumbs={widgetsBreadCrumbs}>
                Menú Contactenos
              </PageTitle>
              <Contactenos />
            </>
          }
        />

        <Route
          path='contactenos/*'
          element={
            <>
              <PageTitle breadcrumbs={widgetsBreadCrumbs}>
                Menú Contactenos
              </PageTitle>
              <ContactenosPage />
            </>
          }
        />

        <Route
          path='reclamaciones'
          element={
            <>
              <PageTitle breadcrumbs={widgetsBreadCrumbs}>
                Libro de Reclamaciones
              </PageTitle>
              <Reclamaciones />
            </>
          }
        />

        <Route
          path='reclamaciones/*'
          element={
            <>
              <PageTitle breadcrumbs={widgetsBreadCrumbs}>
                Libro de Reclamaciones
              </PageTitle>
              <ReclamacionesPage />
            </>
          }
        />

        <Route index element={<Navigate to='/menu/administracion/contactenos' />} />
      </Route>
    </Routes>
  )
}

export default AdministracionPage
